/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */

import CommonObject from "@shared/CommonObject";

const actions = {
	invoiceGroupListLoadMore(context, {limit} = {limit: 20}) {
		if(!context.state.invoiceListPager){
			context.state.invoiceListPager = CommonObject.server.filterInvoices(limit)
		}
		return context.state.invoiceListPager
			.nextOld(data => {
				data = context.state.invoiceListPager.mergeData(context.state.invoiceList || [], data)
				context.commit('SET_INVOICE_LIST', data);
			})
	},
	invoiceGroupListFetch(context, {limit} = {limit: 20}) {
		context.state.invoiceListPager = CommonObject.server.filterInvoices(limit)
		return context.dispatch("invoiceGroupListLoadMore", {limit})
	},

	invoiceGroupUpdate(context, {invoiceGroup}) {
		return CommonObject.server.updateInvoiceGroup(invoiceGroup)
			.then(invoiceGroup => {
				context.commit('UPDATE_INVOICE_ITEM_IN_LIST', invoiceGroup);
			})
	},
	invoiceGroupDelete(context, {invoiceGroup}) {
		return CommonObject.server.deleteInvoiceGroup(invoiceGroup)
			.then(invoiceGroup => {
				context.commit('DELETE_INVOICE_ITEM_IN_LIST', invoiceGroup);
			})
	},
}

export default actions;
